import { z } from "zod"

export const missionOriginRouterStateSchema = z
    .union([
        z.object({
            page: z.literal("flights"),
        }),
        z.object({
            page: z.literal("pilot"),
            pilotId: z.string(),
        }),
        z.object({
            page: z.literal("drone"),
            droneId: z.string(),
        }),
    ])
    .optional()
export type MissionOriginRouterState = z.infer<typeof missionOriginRouterStateSchema>
